import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { BrandsState } from '../../types';

import { deleteFavouriteBrands as deleteFavouriteBrandsOperation } from '../operations/deleteFavouriteBrands';

import { STATUS_LOADING } from 'common/constants';

export const deleteFavouriteBrands = (builder: ActionReducerMapBuilder<BrandsState>) => builder
  .addCase(deleteFavouriteBrandsOperation.pending, (state) => {
    state.favouriteBrands.deletingStatus = STATUS_LOADING.load;
  })
  .addCase(deleteFavouriteBrandsOperation.fulfilled, (state, { payload: { favouriteBrandBillingIds } }) => {
    state.favouriteBrands.deletingStatus = STATUS_LOADING.done;
    state.favouriteBrands.data = state.favouriteBrands.data?.reduce((acc, favouriteBrand) => {
      if (favouriteBrandBillingIds.find(billingId => billingId === favouriteBrand.billingId)) {
        return acc;
      }

      acc?.push(favouriteBrand);
      return acc;
    }, [] as BrandsState['favouriteBrands']['data']);
  })
  .addCase(deleteFavouriteBrandsOperation.rejected, (state) => {
    state.favouriteBrands.deletingStatus = STATUS_LOADING.error;
  });
